export function getCardExperience(metadata = {}) {
  // Every provider uses the same compact fields. Descriptions stay in the profile.
  const jobs = metadata.full_cv?.work_experience || [];
  const job = jobs.find(item => item.title === metadata.current_role) || jobs[0];
  const title = metadata.current_role || job?.title;
  const company = metadata.current_company ||
    (!metadata.current_role || job?.title === metadata.current_role ? job?.company : '');
  if (title) return [title, company].filter(Boolean).join(' at ');
  if (metadata.source === 'jobseeqr_signup' || metadata.pinecone_id?.startsWith('cv-')) return '';

  // Compact fallback for older saved provider profiles without structured jobs.
  const experience = Array.isArray(metadata.experience) ? metadata.experience[0] : metadata.experience;
  return (experience || '').split(/\n|;/)[0].replace(/\s*\(\d{4}-.*$/, '');
}

// Keep the position separate from the company so translation cannot rename it.
export function getCardPosition(metadata = {}) {
  const jobs = metadata.full_cv?.work_experience || [];
  const title = metadata.current_role || metadata.jobTitle || metadata.position;
  const job = jobs.find(item => item.title === title) || jobs[0];
  return {
    title: title || job?.title || '',
    company: metadata.current_company || metadata.company || (!title || job?.title === title ? job?.company : '') || '',
    fallback: getCardExperience(metadata),
  };
}

export function appendUniqueProfiles(previous, incoming) {
  const key = profile => profile.metadata?.pinecone_id || profile.metadata?.linkedin_url || profile.metadata?.user_uid;
  const seen = new Set(previous.map(key).filter(Boolean));
  return [...previous, ...incoming.filter(profile => {
    const id = key(profile);
    if (id && seen.has(id)) return false;
    if (id) seen.add(id);
    return true;
  })];
}
